import { RemiSpinner } from "@remi/next-ui";

export default function Loading() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <RemiSpinner size="lg" />
    </div>
  );
}
